import storage from 'redux-persist/es/storage';
import { persistCombineReducers } from 'redux-persist';

import auth from './auth';
import groups from './groups';
import roles from './roles';
import common from './common';
import courses from './courses';
import school_years from './schoolYears';
import school_weeks from './schoolWeeks';
import candidates from './candidates';
import terms from './terms';
import periods from './periods';
import schedule_variants from './schedule_variants';
import reports from './reports';
import schedule from './schedule';
import classbook from './classbook';
import personnel from './personnel';
import info_main from './info_main';
import method_office from './method_office';
import settings from './settings';
import discipline_structure from './discipline_structure';
import roomTypes from './roomTypes';
import rooms from './rooms';
import students from './students';
import planning from './theme_planning';
import ads from './ads';
import event_type from './event_types';
import FAQ from './FAQ';
import directory from './directory';
import educational_structure from './educational_structure';
import educational_structure2 from './educational_structure2';
import competence from './competence';
import scheduling from './scheduling';
import edu_directions from './edu_directions';
import directoryObjectsUMB from './directoryObjectsUMB';
import culture from './culture';
import formsOfEducation from './formsOfEducation';
import schedule_settings from './schedule_settings';
import studyPlans from './studyPlans';
import subjectsByYearStudy from './subjectsByYearStudy';
import directoryMedCenter from './directoryMedCenter';
import directoryCanteen from './directoryCanteen';
import directoryBasicEducation from './directoryBasicEducation';
import directoryExtraEducation from './directoryExtraEducation';
import directoryExtraCurEducation from './directoryExtraCurEducation';
import event_levels from './event_levels';
import achievements from './achievements';
import do_schedule_variants from './do_schedule_variants';
import act_types from './act_types';
import physical_group from './physical_group';
import achiev_points from './achiev_points';
import vd_schedule_variants from './vd_schedule_variants';
import educ_directions from './educ_directions';
import exams from './exams';
import personalScheduleDO from './personalScheduleDO';
import studyPlansDO from './studyPlansDO';
import studyPlansVD from './studyPlansVD';
import holidays from './holidays';
import fitnessIndicators from './fitnessIndicators';
import stages_study from './stages_study';
import equipment_groups from './equipment_groups';
import equipment from './equipment';
import educational_institutions from './educational_institutions';
import journal_control from './journal_control';
import dailyRoutin from './dailyRoutin';
import events_list from './events_list';
import scheduling_do from './scheduling_do';
import admissions from './admissions';
import typical_comment from './typical_comment';
import report_groups from './reportGroups';
import user_dictionary from './user_dictionary';
import trajectories from './trajectories';
import exam_city from './exam_city';
import exam_board from './exam_board';
import enroll_questions from './enrollQuestions';
import testing_schedule from './testing_schedule';
import backup from './backup';
import publications from './publications';
import log_setting from './log_setting';
import useful_sites from './useful_sites';
import importing_photos from './importing_photos';
import documents_journal from './documents_journal';
import parent_meetings from './parent_meetings';
import structural_divisions from './structural_divisions';
import types_of_documents from './types_of_documents';
import initial_import from './initial_import';
import security_log from './security_log';
import new_school_year from './new_school_year';
import activity from './activity';
import profotbor from './profotbor';
import educationalMethodologicalKits from './educationalMethodologicalKits';
import method_assoc_levels from './method_assoc_levels';
import method_assoc from './method_assoc';
import applicantQuestionSet from './applicantQuestionSet';
import time_slot from './time_slot';
import video_config from './video_config';
import video_records from './video_records';
import tv_program_type from './tv_program_type';
import tv_program_schedule from './tv_program_schedule';
import applicant_group from './applicant_group';
import orders from './orders';
import dashboard from './dashboard';
import datasets from './datasets';
import web_lessons from './web_lessons';
import groups_do_vd from './groups_do_vd';
import library from './library';


const storageConfig = { whitelist: 'auth', key: 'certification_storage', storage };

export default persistCombineReducers(storageConfig, {
  auth,
  activity,
  web_lessons,
  profotbor,
  dashboard,
  common,
  courses,
  candidates,
  scheduling,
  groups,
  periods,
  reports,
  roles,
  school_years,
  school_weeks,
  schedule_variants,
  schedule,
  terms,
  classbook,
  personnel,
  info_main,
  method_office,
  settings,
  students,
  discipline_structure,
  roomTypes,
  rooms,
  planning,
  ads,
  event_type,
  FAQ,
  directory, // ВСЕ СПРАВОЧНИКИ
  educational_structure,
  educational_structure2,
  competence,
  edu_directions,
  educ_directions,
  directoryObjectsUMB,
  culture,
  formsOfEducation,
  schedule_settings,
  studyPlans,
  subjectsByYearStudy,
  directoryMedCenter, // МЕДПУНКТ СПРАВОЧНИКИ
  directoryCanteen, // СТОЛОВАЯ СПРАВОЧНИКИ
  directoryBasicEducation, // ОСНОВНОЕ ОБРАЗОВАНИЕ СПРАВОЧНИКИ
  directoryExtraEducation, // ДОПОЛНИТЕЛЬНОЕ ОБРАЗОВАНИЕ СПРАВОЧНИКИ
  directoryExtraCurEducation, // Внеурочная деятельность СПРАВОЧНИКИ
  event_levels,
  achievements,
  do_schedule_variants,
  vd_schedule_variants,
  act_types,
  physical_group,
  achiev_points,
  exams,
  personalScheduleDO,
  studyPlansDO,
  studyPlansVD,
  holidays,
  fitnessIndicators,
  stages_study,
  equipment_groups,
  equipment,
  educational_institutions,
  dailyRoutin,
  journal_control,
  events_list,
  scheduling_do,
  admissions,
  typical_comment,
  report_groups,
  user_dictionary,
  trajectories,
  exam_city,
  exam_board,
  enroll_questions,
  testing_schedule,
  backup,
  publications,
  log_setting,
  useful_sites,
  importing_photos,
  documents_journal,
  parent_meetings,
  structural_divisions,
  types_of_documents,
  initial_import,
  security_log,
  new_school_year,
  educationalMethodologicalKits,
  method_assoc_levels,
  method_assoc,
  applicantQuestionSet,
  time_slot, // временные слоты
  video_config,
  video_records,
  tv_program_type,
  tv_program_schedule,
  applicant_group,
  orders,
  datasets, // описание таблиц
  groups_do_vd, // Группы ДО/ВД
  library, // фильтры мероприятий
});